export default __webpack_public_path__ + "static/group-creation-one-c3275b0d7ee9de8e97cb9d9df10a72ba.png";